import React, {Component} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

class ConfirmBox extends Component {

    render() {
        const buttons = this.props.onConfirms.map(button=>(
            <Button key={button.label} color={button.styleName} onClick={button.onClick}>{button.label}</Button>
        ));
        return (
            <div>
                <Modal isOpen={this.props.modal} modalTransition={{timeout: 20}} backdropTransition={{timeout: 10}}
                       toggle={this.toggle} className='danger'>
                    <ModalHeader toggle={this.toggle}>Potwierdzenie anulowania terminu</ModalHeader>
                    <ModalBody>
                       Czy na pewno chcesz anulować ten termin?
                    </ModalBody>
                    <ModalFooter>
                        {buttons}
                        <Button color="danger" onClick={this.props.onCancel}>Anuluj</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

}

export default ConfirmBox


// WEBPACK FOOTER //
// ./src/components/UI/ConfirmBox/ConfirmBox.js